import { StatusApproval } from "../shared/enums/StatusApproval";
import { Consultant } from "./Consultant.model";
import { Approver } from "./Approver.model";
import { ProjectToApproval } from './ProjectToApproval.model';
import { ApprovalType } from "../shared/enums/ApprovalType";
import { ConsultantApproval } from "./ConsultantApproval.model";
import * as _ from 'lodash';
import { ElegibleForDiscount } from "./ElegibleForDiscount.model";
import { ManualApproval } from "./ApprovalManual.model";
import { ApprovalBorrowInvoice } from './ApprovalBorrowInvoice';
import { ApprovalInvoice } from "./ApprovalInvoice.model";

export class Approval {
    _id: String;
    consultant: ConsultantApproval = new ConsultantApproval();
    status: StatusApproval;
    projects;
    date: Date;
    dateApproved: Date;
    approver: Approver;
    approvalType: number;
    realizedHours: number = 0;
    approvedHours: number = 0;
    totalValue: number = 0;
    discounted: Boolean = false;
    discountValue:number = 0;
    discountHours:number = 0;
    extrasValue:number = 0;
    extrasHours:number = 0;
    extras: Boolean = false;
    monthCapacity:number = 0;
    elegibleForDiscount: ElegibleForDiscount;
    manualApproval:ManualApproval;
    dateEdited:Boolean = false;
    created: Date;
    changed: Date;
    sapDocEntry: String;
    sapIntegrated: Boolean = false;
    borrowedInvoice: ApprovalBorrowInvoice;
    retroactiveApproval: Boolean = false;
    approvalExpense: Boolean = false;
    groups: any;
    hash: string;
    completedFill: boolean = false;
    approvalInvoice: ApprovalInvoice = new ApprovalInvoice();
    existsInvoice: boolean = false;
    accountingTotalValue: number = 0;
    valueChangedByUpload: boolean = false;

    constructor(data?) {
        this.populate(data);
    }

    populate(data) {
        _.forOwn(data, (value, key) => {
            this[key] = value;
        })
    }

    loadFromServer(r: any) {

        if (r.consultant !== undefined)
            this.consultant.loadToApprovalsGrid(r.consultant);

        if (r.status !== undefined)
            this.status = parseInt(r.status);

        if (r.projects !== undefined) {

            for (let p of r.projects) {
                let projectFromServer = new ProjectToApproval();
                projectFromServer.hashTrackId = p.hashTrackId;
                projectFromServer.name = p.name;
                projectFromServer.total_hours = p.total_hours;
                projectFromServer.projectFinancialId = p.projectFinancialId;
                projectFromServer.excellenceCenter = p.excellenceCenter;
                projectFromServer.approvedHours = p.approvedHours;
                projectFromServer.approvedValue = p.approvedValue;
                projectFromServer.projectExpense = p.projectExpense;

                if (p.customer !== undefined) {
                    projectFromServer.customer.loadFromServer(p.customer);

                }

                this.projects.push(projectFromServer);
            }
        }

        if (r.date !== undefined)
            this.date = r.date;

        if (r.hash !== undefined)
            this.hash = r.hash;

        if (r.completedFill !== undefined)
            this.completedFill = r.completedFill;

        if (r.dateApproved !== undefined)
            this.dateApproved = r.dateApproved;

        if (r.approver !== undefined)
            this.approver.loadFromServer(r.approver);

        if (r.approvalType !== undefined)
            this.approvalType = parseInt(r.approvalType);

        if (r.realizedHours !== undefined)
            this.realizedHours = r.realizedHours;

        if (r.approvedHours !== undefined)
            this.approvedHours = r.approvedHours;

        if (r.totalValue !== undefined)
            this.totalValue = r.totalValue;

        if (r.created !== undefined)
            this.created = r.created;

        if (r.changed !== undefined)
            this.changed = r.changed;

        if (r.consultant !== undefined)
            this.consultant.loadToApproval(r.consultant);

        if(r._id !== undefined)
            this._id = r._id

        if(r.sapDocEntry !== undefined)
          this.sapDocEntry = r.sapDocEntry

        if(r.sapIntegrated !== undefined)
          this.sapIntegrated = r.sapIntegrated;

        if(r.borrowedInvoice)
            this.borrowedInvoice = r.borrowedInvoice;

        if(r.retroactiveApproval)
            this.retroactiveApproval = r.retroactiveApproval;

        if(r.approvalExpense)
            this.approvalExpense = r.approvalExpense;

        if(r.approvalInvoice !== undefined)
            this.approvalInvoice.loadFromServer(r.approvalInvoice);

        if (r.accountingTotalValue !== undefined)
            this.accountingTotalValue = r.accountingTotalValue;
        
        if (r.valueChangedByUpload !== undefined)
            this.valueChangedByUpload = r.valueChangedByUpload;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/Approval.model.ts